import { FIELDS } from '../../../constants';

const pendingVrmaFields = [
  {
    title: 'RMA No',
    field: FIELDS.ID,
  },
  {
    title: 'RMA Date',
    cell: 'formatDate',
    field: FIELDS.R_MADATE,
  },
  {
    title: 'Sub Total',
    field: FIELDS.SUB_TOTAL,
    
  },
  {
    title: 'Charges',
    field: FIELDS.TOTAL_CHARGES,
    
  },
  {
    title: 'Total',
    field: FIELDS.TOTAL,
    
  }
];

export default pendingVrmaFields;
